(() => {
  if(window.__pi15VideosInitialized)return;
  window.__pi15VideosInitialized=true;
  const sectionSelector='product-info.pi15-smooth [data-pi15-film-room]';
  function initialize(){
    const section=document.querySelector(sectionSelector);
    if(!section||section.dataset.pi15VideoReady==='true')return;
    section.dataset.pi15VideoReady='true';
    const cards=[...section.querySelectorAll('[data-pi15-video-card]')];
    const track=section.querySelector('[data-pi15-reals-track]');
    const previous=section.querySelector('[data-pi15-prev]');
    const next=section.querySelector('[data-pi15-next]');

    function setVisual(card,playing){
      card.classList.toggle('is-playing',playing);
      const btn=card.querySelector('[data-pi15-play]');
      if(btn){
        btn.setAttribute('aria-label',playing?'Videoyu duraklat':'Gerçek baskı videosunu oynat');
      }
    }
    function pauseOther(current){
      cards.forEach(card=>{
        const video=card.querySelector('[data-pi15-video]');
        if(video&&video!==current&&!video.paused)video.pause();
      });
    }
    cards.forEach(card=>{
      const video=card.querySelector('[data-pi15-video]');
      const play=card.querySelector('[data-pi15-play]');
      if(!video||!play)return;
      video.controls=false;
      video.preload='none';
      // The user deliberately starts each video; no four-video simultaneous autoplay.
      play.addEventListener('click',async()=>{
        if(!video.paused){video.pause();return}
        pauseOther(video);
        video.controls=true;
        try{
          await video.play();
          setVisual(card,true);
        }catch(error){
          video.controls=true;
          setVisual(card,false);
        }
      });
      video.addEventListener('play',()=>{pauseOther(video);setVisual(card,true)});
      video.addEventListener('pause',()=>setVisual(card,false));
      video.addEventListener('ended',()=>setVisual(card,false));
    });

    const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting)return;
        const video=entry.target.querySelector('[data-pi15-video]');
        if(video&&!video.paused)video.pause();
      });
    },{rootMargin:'100px 0px',threshold:0}):null;
    if(observer)cards.forEach(card=>observer.observe(card));

    function stepCarousel(dir){
      if(!track)return;
      const card=cards[0];
      const stride=card?card.getBoundingClientRect().width+13:track.clientWidth*.78;
      track.scrollBy({left:dir*stride,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    previous?.addEventListener('click',()=>stepCarousel(-1));
    next?.addEventListener('click',()=>stepCarousel(1));
    function updateNavigation(){
      if(!track||!previous||!next)return;
      const max=track.scrollWidth-track.clientWidth;
      previous.disabled=track.scrollLeft<10;
      next.disabled=max-track.scrollLeft<10;
    }
    track?.addEventListener('scroll',updateNavigation,{passive:true});
    window.addEventListener('resize',updateNavigation,{passive:true});
    updateNavigation();
  }
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('DOMContentLoaded',initialize);
  if(document.readyState!=='loading')initialize();
})();